import { Controller } from "@hotwired/stimulus";

const MOBILE_BREAKPOINT = 768;

/**
 * ハーフモーダル・ポップアップの制御
 * @example
 * <div
 *   data-controller="half-modal-popover"
 *  <button
 *    type="button"
 *    data-half-modal-popover-target="button"
 *    data-action="click->half-modal-popover#show">表示ボタン</button>
 *  <div
 *    data-half-modal-popover-target="popover">
 *    <div data-half-modal-popover-target="content">内容</div>
 *  </div>
 * </div>
 */
export class HalfModalPopoverController extends Controller {
  // button: 表示させるためのボタン
  // popover: ポップオーバーの親要素
  // content: ポップオーバーの中身
  static targets = ["button", "popover", "content"];
  #isOpen = false;

  toggle() {
    if (this.#isOpen) {
      this.close();
    } else {
      this.show();
    }
  }

  show() {
    if (this.isMobile()) {
      this.showHalfModal();
    } else {
      this.showPopover();
    }
    this.#isOpen = true;
  }

  close() {
    if (!this.popoverTarget.classList.contains("is-open")) return;

    this.popoverTarget.classList.remove("is-open");
    this.buttonTarget.classList.remove("is-top");
    this.buttonTarget.classList.remove("is-bottom");
    setTimeout(() => {
      this.popoverTarget.style.top = "";
      this.popoverTarget.style.bottom = "";
    }, 300);
    this.#isOpen = false;
  }

  click(e) {
    if (!this.#isOpen) return;

    if (this.isMobile()) {
      // ハーフモーダルの場合
      // モーダルの中身またはボタン以外をクリックしたら閉じる
      if (!this.contentTarget.contains(e.target) && !this.buttonTarget.contains(e.target)) {
        this.close();
      }
    } else {
      // ポップオーバーの場合
      // ポップオーバーまたはボタン以外をクリックしたら閉じる
      if (!this.popoverTarget.contains(e.target) && !this.buttonTarget.contains(e.target)) {
        this.close();
      }
    }
  }

  isMobile() {
    return window.innerWidth < MOBILE_BREAKPOINT;
  }

  showHalfModal() {
    this.popoverTarget.classList.add("is-open");
    this.popoverTarget.setAttribute("tabindex", "-1");
    this.popoverTarget.focus();
  }

  showPopover() {
    const windowH = window.innerHeight;
    const targetRect = this.buttonTarget.getBoundingClientRect();

    //ボタン位置が画面の下の方であれば上に出す
    if (windowH / 2 + 100 > targetRect.top) {
      const top = this.buttonTarget.offsetHeight + 8;
      this.popoverTarget.style.top = `${top}px`;
      this.buttonTarget.classList.add("is-top");
    } else {
      const bottom = this.buttonTarget.offsetHeight + 8;
      this.popoverTarget.style.bottom = `${bottom}px`;
      this.buttonTarget.classList.add("is-bottom");
    }

    this.popoverTarget.classList.add("is-open");
  }
}

// クリックを各モーダルに通知するためのコントローラ
// イベント大量に登録&発火するの嫌だから作ったが、結局各モーダルの処理呼び出すので微妙か？
export class HalfModalPopoverManagerController extends Controller {
  static outlets = ["half-modal-popover"];

  docClick(e) {
    this.halfModalPopoverOutlets.forEach((halfModalPopover) => {
      halfModalPopover.click(e);
    });
  }

  docClickOnSalesStatements(e) {
    this.promotersSalesStatementsOutlets.forEach((halfModalPopover) => {
      halfModalPopover.click(e);
    });
  }
}
